import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esChronicPain } from "@/pages/es/esConditionData3";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/chronic-pain-coral-springs-fl")({
  head: () => buildEsConditionHead(esChronicPain),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esChronicPain} />;
}
